import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {IconBox, IconBoxSize} from '@Components/icon-box';
import {IconSize} from '@Components/icon-v2/icon.types';
import {noop} from '@Utils/general.util';
import styles from './auto-branding.module.scss';
import {ColorPaletteSize} from '@Components/color-palettes/color-palette/color-palette.types';
import {ColorPalette} from '@Components/color-palettes/color-palette/color-palette';
import type {ColorPaletteInfo} from '@Libraries/color-palettes.library';

export interface AutoBrandingProps {
  appliedPalette?: ColorPaletteInfo | null;
  onPaletteAdd?: VoidFunction;
  onPaletteSelect?: VoidFunction;
  onPaletteEdit?: (currentColorPalette: ColorPaletteInfo | null) => void;
}

export function AutoBranding({appliedPalette = null, onPaletteAdd = noop, onPaletteSelect = noop, onPaletteEdit = noop}: AutoBrandingProps): ReactElement<any> {
  const getColorPaletteLabel = (): ReactElement<any> => {
    return (
      <div className={styles.labelContainer}>
        <Text val={window.i18next.t('pmwjs_styles')} size={TextSize.XSMALL} className="content-body" />
      </div>
    );
  };

  const doesColorPaletteExist = (): boolean => {
    return appliedPalette !== null && appliedPalette.colors.length > 0;
  };

  const getColorPaletteIconClickHandler = (): VoidFunction => {
    return doesColorPaletteExist()
      ? (): void => {
          onPaletteEdit(appliedPalette);
        }
      : onPaletteAdd;
  };

  const getColorPaletteIcon = (): ReactElement<any> => {
    const icon = doesColorPaletteExist() ? 'icon-pencil' : 'icon-plus';
    const clickHandler = getColorPaletteIconClickHandler();

    return <IconBox icon={icon} className={styles.icon} size={IconBoxSize.SMALL} iconSize={IconSize.SIZE_ICON_16} onClick={clickHandler} />;
  };

  const getAutoBrandingComponent = (): ReactElement<any> => {
    return (
      <div className={styles.container}>
        {getColorPaletteLabel()}
        <div className={styles.colorPaletteContainer}>
          <ColorPalette palette={appliedPalette ?? undefined} size={ColorPaletteSize.SMALL} onClick={onPaletteSelect} />
          {getColorPaletteIcon()}
        </div>
      </div>
    );
  };

  return getAutoBrandingComponent();
}
